import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './DoctorPublicList.css';

export default function DoctorPublicList() {
    const [doctors, setDoctors] = useState([]);
    const [fields, setFields] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalDoctors, setTotalDoctors] = useState(0);
    const [addressFilter, setAddressFilter] = useState('');
    
    const API_URL = process.env.REACT_APP_API_URL;
    const perPage = 10;

    useEffect(() => {
        fetchFields();
    }, []);

    useEffect(() => {
        if (Object.keys(fields).length > 0) {
            fetchDoctors();
        }
    }, [currentPage, fields, addressFilter]);

    const fetchFields = async () => {
        try {
            const response = await axios.get(`${API_URL}fetch-fields`);
            const fieldsMap = {};
            response.data.forEach(field => {
                fieldsMap[field.field_id] = field.name;
            });
            setFields(fieldsMap);
        } catch (err) {
            console.error('Error fetching fields:', err);
        }
    };

    const fetchDoctors = async () => {
        setLoading(true);
        setError('');
        try {
            const response = await axios.get(`${API_URL}doctors/all-paginated`, {
                params: {
                    per_page: perPage,
                    page: currentPage,
                    sort: 'created',
                    order: 'asc',
                    address: addressFilter || undefined
                }
            });

            if (response.data && response.data.data) {
                setDoctors(response.data.data);
                setTotalPages(response.data.meta.last_page);
                setTotalDoctors(response.data.meta.total);
            }
        } catch (err) {
            setError('Failed to load doctors');
            console.error('Error fetching doctors:', err);
        } finally {
            setLoading(false);
        }
    };

    const formatDoctorText = (doctor) => {
        const specialization = fields[doctor.field_id] || 'غير محدد';
        const brief = doctor.brief || '';
        const phone = doctor.phone_number || '';
        const address = doctor.clinic_address || '';
        
        // Build location links
        let locationText = '';
        if (doctor.clinic_latitude && doctor.clinic_longitude) {
            const googleMapsUrl = `https://www.google.com/maps?q=${doctor.clinic_latitude},${doctor.clinic_longitude}`;
            const wazeUrl = `https://www.waze.com/ul?ll=${doctor.clinic_latitude},${doctor.clinic_longitude}&navigate=yes`;
            locationText = `ويز: ${wazeUrl} \n خرائط كوكل: ${googleMapsUrl}`;
        }

        return `عيادة الدكتور ${doctor.full_name}

اختصاص: ${specialization}

${brief}

هاتف: ${phone}

العنوان: ${address}

${locationText}

#بغداد #شارع_فلسطين #ساحة_بيروت #عيادة #خريطة_العراق
`;
    };

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text).then(() => {
    
        }).catch(err => {
            console.error('Failed to copy:', err);
        });
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    if (loading && doctors.length === 0) {
        return (
            <div className="doctor-public-list-container">
                <div className="loading-spinner">جاري التحميل...</div>
            </div>
        );
    }

    return (
        <div className="doctor-public-list-container">
            <div className="page-header">
                <h2>قائمة الأطباء للنشر</h2>
                <p className="total-count">إجمالي الأطباء: {totalDoctors}</p>
                <div className="filter-section">
                    <input
                        type="text"
                        className="address-filter-input"
                        placeholder="فلترة حسب العنوان..."
                        value={addressFilter}
                        onChange={(e) => {
                            setAddressFilter(e.target.value);
                            setCurrentPage(1);
                        }}
                    />
                    {addressFilter && (
                        <button
                            className="clear-filter-button"
                            onClick={() => {
                                setAddressFilter('');
                                setCurrentPage(1);
                            }}
                        >
                            ✕
                        </button>
                    )}
                </div>
            </div>

            {error && (
                <div className="error-message">{error}</div>
            )}

            <div className="doctors-list">
                {doctors.map((doctor) => {
                    const doctorText = formatDoctorText(doctor);
                    return (
                        <div key={doctor.doctor_id} className="doctor-card">
                            <div className="doctor-text-content">
                                <pre className="doctor-text">{doctorText}</pre>
                            </div>
                            <button 
                                className="copy-button"
                                onClick={() => copyToClipboard(doctorText)}
                            >
                                نسخ النص
                            </button>
                        </div>
                    );
                })}
            </div>

            {totalPages > 1 && (
                <div className="pagination-controls">
                    <button 
                        onClick={handlePrevPage} 
                        disabled={currentPage === 1}
                        className="pagination-button"
                    >
                        السابق
                    </button>
                    <span className="page-info">
                        صفحة {currentPage} من {totalPages}
                    </span>
                    <button 
                        onClick={handleNextPage} 
                        disabled={currentPage === totalPages}
                        className="pagination-button"
                    >
                        التالي
                    </button>
                </div>
            )}
        </div>
    );
}
